import { FC, useState } from "react";

import {
  COURSE_CODE_GROUPING_ID_QUERY_PARAM,
  COURSE_CODE_ID_QUERY_PARAM,
} from "components/constants";
import { EditableField } from "components/hover-widgets/EditableField";
import { CourseCodeOptionsMenu } from "components/menus/CourseOptionsMenu";
import { CourseType } from "components/server-types";
import { t } from "i18n/i18n";
import { ListItem } from "mds/components/ListItem";
import { TextBooksIcon } from "mds/icons";
import { useQueryParamsManager } from "utils/routing";
import { onTitleChanged } from "utils/store-utils";

type CourseListItemProps = {
  courseCode: CourseType;
  canEdit: boolean;
  eventPrefix?: string;
};

export const CourseCodeListItem: FC<CourseListItemProps> = ({
  courseCode,
  canEdit,
  eventPrefix,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const { setQueryParams } = useQueryParamsManager();

  return (
    <ListItem
      eventName={`${eventPrefix || ""}Course Code selected`}
      eventProperties={{ courseCode: courseCode.title }}
      kind="primary"
      onClick={() => {
        setQueryParams({
          [COURSE_CODE_ID_QUERY_PARAM]: courseCode.id,
          [COURSE_CODE_GROUPING_ID_QUERY_PARAM]: null,
        });
      }}
    >
      <div className="body-m flex w-full min-w-12 items-center justify-between gap-2">
        <div className="flex w-full min-w-12 items-center gap-2">
          <TextBooksIcon />

          <EditableField
            className="w-full min-w-12 truncate"
            isEditing={isEditing}
            label={t("glossary.course_code_title")}
            textSize="m"
            value={courseCode.title}
            onSetIsEditing={setIsEditing}
            onValueChanged={(newTitle) =>
              onTitleChanged("course_codes", courseCode.id, newTitle, {
                eventName: "Course Code - Change title",
              })
            }
          />
        </div>

        {canEdit && (
          <CourseCodeOptionsMenu
            courseCode={courseCode}
            eventPrefix={eventPrefix}
            onRename={() => setIsEditing(true)}
          />
        )}
      </div>
    </ListItem>
  );
};
